
import { http } from "../http/Http";
import { AuthenticateUser } from "../models/AuthenticateUser";
import { AuthenticateResponse } from "../models/AuthenticateResponse";

export class AuthenticateService {

    authenticate = async (authenticateUser: AuthenticateUser): Promise<AuthenticateResponse> => {
        const { data } = await http.post<AuthenticateResponse>("User/Authenticate", authenticateUser);
        return data;
    };

    logitudeAuthenticate = async (logitudeAuthenticateUser: { Tenant: number, Token: string }): Promise<AuthenticateResponse> => {
        const { data } = await http.post<AuthenticateResponse>("User/LogitudeAuthenticate", logitudeAuthenticateUser);
        return data;
    };

    isValidToken = async (token: string): Promise<boolean> => {
        const { data } = await http.get<boolean>("User/IsValidToken?token=" + token);
        return data;
    };

}